import React, { FC } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import { handleMonthInput, MonthPicker } from '@common/datePicker';
import ErrorMessage from '@components/profile/profileOverlay/common/ErrorMessage';
import styles from '../../prize.module.scss';
import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

type IPrizeDateProps = Omit<UseControllerProps, 'name'> & {
  prefixName: string;
  dateDefaultValue?: string;
};

const PrizeDate: FC<IPrizeDateProps> = ({ prefixName, dateDefaultValue, ...props }) => {
  const dateName = `${prefixName}.date`;
  const {
    field: dateField,
    fieldState: { invalid: dateInvalid },
  } = useController({
    ...props,
    name: dateName,
    defaultValue: dateDefaultValue,
  });
  const selected = dateField.value ? new Date(dateField.value) : null;
  const dateInputComplete = !!dateField.value;

  const handleChange = (date: Date | null) => {
    if (!date) return;
    dateField.onChange(DateFormat.format(date, 'yyyy-MM'));
  };

  return (
    <div className={cx('awardWrap')}>
      <div className={cx('awardTitle')}>수상 일자</div>

      <div className={cx('inputArea')}>
        <MonthPicker
          selected={selected}
          onChange={handleChange}
          onChangeRaw={handleMonthInput}
          className={cx('input', 'date', { error: dateInvalid }, { complete: dateInputComplete })}
          placeholderText="연도. 월"
          maxDate={new Date('9999-12')}
        />
        <ErrorMessage name={dateName} />
      </div>
    </div>
  );
};

export default PrizeDate;
